/* eslint-disable react/forbid-prop-types,import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import { dynamicAssets } from '../../../../utilities/helpers';

export const PasswordValidationPopUp = ({ translate, pswdValidation, showPopUp, bgColor }) => {
  const renderValidationContent = () => (
    <div className="password_validation">
      <i
        className="position-absolute d-md-none start-0 shadow"
        style={{ marginTop: '0.5rem', marginLeft: '-8px' }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="15"
          viewBox="0 0 8 15"
          fill="none">
          <path d="M0 7.88574L8 14.8857L8 0.885742L0 7.88574Z" fill="#272727" />
        </svg>
      </i>
      <div id="row">
        <p className="mb-2">
          <strong>{translate('password_validation_popup_title')}</strong>
        </p>
        <ul className="list-unstyled m-0">
          <li>
            <img
              className="p-1"
              src={dynamicAssets(
                `./assets/images/${pswdValidation.isLongEnough ? 'done' : 'cancel'}.svg`
              )}
              alt="icon"
            />
            <span className="p-1">{translate('password_validation_char')}</span>
          </li>
          <li>
            <img
              className="p-1"
              src={dynamicAssets(
                `./assets/images/${pswdValidation.hasUppercaseLetter ? 'done' : 'cancel'}.svg`
              )}
              alt="icon"
            />
            <span className="p-1">{translate('password_validation_letter_uppercase')}</span>
          </li>
          <li>
            <img
              className="p-1"
              src={dynamicAssets(
                `./assets/images/${pswdValidation.hasLowercaseLetter ? 'done' : 'cancel'}.svg`
              )}
              alt="icon"
            />
            <span className="p-1">{translate('password_validation_letter_lowercase')}</span>
          </li>
          <li>
            <img
              className="p-1"
              src={dynamicAssets(
                `./assets/images/${pswdValidation.hasNumber ? 'done' : 'cancel'}.svg`
              )}
              alt="icon"
            />
            <span className="p-1">{translate('password_validation_number')}</span>
          </li>
          <li>
            <img
              className="p-1"
              src={dynamicAssets(
                `./assets/images/${
                  pswdValidation.hasSpecialCharacter && !pswdValidation.hasNotAllowerSpecislChars
                    ? 'done'
                    : 'cancel'
                }.svg`
              )}
              alt="icon"
            />
            <span className="p-1">{translate('password_validation_special_char')}</span>
          </li>
        </ul>
      </div>
    </div>
  );

  if (!showPopUp) return null;

  return (
    <>
      {/* browser */}
      <div className="d-none d-md-block">{renderValidationContent()}</div>

      {/* mobile */}
      <div
        className="position-absolute d-md-none"
        style={{
          width: '100%',
          zIndex: '2000',
        }}>
        <div
          className="shadow"
          style={{
            width: '0',
            height: '0',
            borderLeft: '0.75rem solid transparent',
            borderRight: '0.75rem solid transparent',
            borderTop: '0.75rem solid #272727',
            margin: 'auto',
            transform: 'rotate(180deg)',
          }}
        />
        <div
          className={`shadow p-3 ${bgColor}`}
          style={{
            marginTop: '-1.5rem',
            width: 'max-content',
            borderRadius: '1rem',
            margin: 'auto',
          }}>
          {renderValidationContent()}
        </div>
      </div>
    </>
  );
};

PasswordValidationPopUp.propTypes = {
  translate: PropTypes.any.isRequired,
  pswdValidation: PropTypes.shape({
    isLongEnough: PropTypes.bool,
    hasUppercaseLetter: PropTypes.bool,
    hasLowercaseLetter: PropTypes.bool,
    hasNumber: PropTypes.bool,
    hasSpecialCharacter: PropTypes.bool,
    hasNotAllowerSpecislChars: PropTypes.bool,
  }).isRequired,
  showPopUp: PropTypes.bool.isRequired,
  bgColor: PropTypes.string,
};

PasswordValidationPopUp.defaultProps = {
  bgColor: 'bg-lighter',
};
